import axiosInstance from "../axiosInstance";
import axiosInstanceAdm from "../axiosInstanceAdm";
import mobileAxiosInstance from "../mobileAxiosInstance";

export const sendGetRequestMobile = async (URL, signal) => {
  const res = await mobileAxiosInstance.get(URL, signal);
  return res;
};

export const sendPostRequestMobile = async (URL, params) => {
  const res = await mobileAxiosInstance.post(URL, params);
  return res;
};

export const sendGetRequest = async (URL, signal) => {
  const res = await axiosInstance.get(URL, signal);
  return res;
};

export const sendPostRequest = async (URL, params) => {
  const res = await axiosInstance.post(URL, params);
  return res;
};

export const sendGetDownloadRequest = async (URL, params) => {
  const res = await axiosInstance.get(URL, {
    responseType: "blob",
  });
  return res;
};

export const sendPostDownloadRequest = async (URL, params) => {
  const res = await axiosInstance.post(URL, params, {
    responseType: "blob",
  });
  return res;
};

export const sendPostMultipartRequest = async (URL, params) => {
  const formData = new FormData();

  Object.keys(params).forEach((fieldName) => {
    if (Array.isArray(params[fieldName])) {
      console.log("customer array");
      params[fieldName].map((a) => {
        formData.append(fieldName, a);
      });
      return;
    }
    formData.append(fieldName, params[fieldName]);
  });

  const res = await axiosInstance.post(URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const sendPostMultipartRequestv2 = async (URL, params) => {
  const getFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      console.log(formData);
      return formData;
    }, new FormData());

  const res = await axiosInstance.post(URL, getFormData(params), {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const sendPatchRequest = async (URL, params) => {
  const res = await axiosInstance.patch(URL, params);
  return res;
};

export const sendPutRequest = async (URL, params) => {
  const res = await axiosInstance.put(URL, params);
  return res;
};

export const sendDeleteRequest = async (URL) => {
  const res = await axiosInstance.delete(URL);
  return res;
};

// NEW API V2
export const sendGetRequestAdm = async (URL, signal) => {
  const res = await axiosInstanceAdm.get(URL, signal);
  return res;
};

export const sendPostRequestAdm = async (URL, params) => {
  const res = await axiosInstanceAdm.post(URL, params);
  return res;
};

export const sendGetDownloadRequestAdm = async (URL, params) => {
  const res = await axiosInstanceAdm.get(URL, params, {
    responseType: "blob",
  });
  return res;
};

export const sendPostDownloadRequestAdm = async (URL, params) => {
  const res = await axiosInstanceAdm.post(URL, params, {
    responseType: "blob",
  });
  return res;
};

export const sendPostMultipartRequestAdm = async (URL, params) => {
  const formData = new FormData();

  Object.keys(params).forEach((fieldName) => {
    if (Array.isArray(params[fieldName])) {
      console.log("customer array");
      params[fieldName].map((a) => {
        formData.append(fieldName, a);
      });
      return;
    }
    formData.append(fieldName, params[fieldName]);
  });

  const res = await axiosInstanceAdm.post(URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const sendPostMultipartRequestAdmv2 = async (URL, params) => {
  const getFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      console.log(formData);
      return formData;
    }, new FormData());

  const res = await axiosInstanceAdm.post(URL, getFormData(params), {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res;
};

export const sendPatchRequestAdm = async (URL, params) => {
  const res = await axiosInstanceAdm.patch(URL, params);
  return res;
};

export const sendPutRequestAdm = async (URL, params) => {
  const res = await axiosInstanceAdm.put(URL, params);
  return res;
};

export const sendDeleteRequestAdm = async (URL) => {
  const res = await axiosInstanceAdm.delete(URL);
  return res;
};

export const generateErrorMessage = (error) => {
  const message = error.response.data.message;
  let detail;

  if (error.response.data.errors?.length > 0) {
    const errors = error.response.data.errors;

    if (typeof errors === "object") {
      detail = [];
      Object.keys(errors).forEach((key) => {
        errors[key].forEach((err) => detail.push(`${err}`));
      });

      detail = detail.join(", ");
    } else if (typeof errors === "string") {
      detail = errors;
    }
  } else {
    detail = message;
  }

  return `${detail ?? "Unexpected error happened"}`;
};
